import React , {Component} from 'react';
import { Row } from 'antd';
import "../../asset/style/morpheus.css"
import "../../asset/style/landing.css"

export class DemoScans extends Component {

    render(){
        return(
            <Row className="demo-scans-parent full-widther">
                Demo Scans
            </Row>
        )
    }
  }